// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import axios from './http'
import store from './store'
import { btn_extimate, BTN } from "@/utils/btnAuth.js";
// require('!style-loader!css-loader!less-loader!./common/css/template.less')
Vue.config.productionTip = false
Vue.prototype.lockScroll = true;
Vue.prototype.closeModal=false;
Vue.prototype.$axios = axios;
Vue.prototype.btn_extimate = btn_extimate;
Vue.prototype.BTN = BTN;
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  components: { App },
  template: '<App/>',
  store,
})



// WEBPACK FOOTER //
// ./src/main.js